module.exports = __webpack_public_path__ + "img/f85a2ec.svg";